import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCubeBack = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.21526 0H3.94775L3.80519 0.213842C3.80096 0.219898 3.79686 0.226051 3.79289 0.232299L3.65442 0.440002H3.64V0.461632L0.0876514 5.79018L0.0797824 5.80198L0 5.92165V6.07304V6.07305V13.5038V14.0038H0.5H10.7172H11.0262L11.1644 13.7274L13.9509 8.15433L14.0037 8.04875V7.93072V0.5V0H13.5037H4.21535H4.21526ZM3.64 2.26441L1.43425 5.57305H3.64V2.26441ZM3.64 6.57305H1V12.0651C1.1605 11.8874 1.43036 11.8461 1.63914 11.9789C1.87211 12.1272 1.94079 12.4362 1.79253 12.6692L1.57963 13.0038H10.2172V8.44H4.48383L4.23073 8.83774C4.08247 9.07071 3.77343 9.13938 3.54046 8.99113C3.30749 8.84288 3.23881 8.53383 3.38706 8.30086L3.64 7.90339V6.57305ZM11.2172 8.44V11.3857L12.6901 8.44H11.2172ZM3.2646 9.42462C3.49757 9.57288 3.56625 9.88192 3.418 10.1149L2.60526 11.392C2.45701 11.625 2.14797 11.6937 1.915 11.5454C1.68202 11.3972 1.61335 11.0881 1.7616 10.8552L2.57433 9.57802C2.72259 9.34505 3.03163 9.27637 3.2646 9.42462Z",
		fill: "white"
	})]
});
export default SvgCubeBack;
